<template>
  <v-app
  >
    <v-app-bar 
      color="primary"
      dark
      short
      max-height="56"
    >
      <v-container :class="{contain: $vuetify.breakpoint.mdAndUp}">
        <v-row>
          <v-col :cols="6" class="text-left">
            <v-img src="./assets/rightLogo.png" :height="54" :max-width="150" alt="Discraft" />
          </v-col>
          <v-col class="text-right my-3">
            <v-btn to="/" right color="primary" dark>
              <v-icon>mdi-home</v-icon>
            </v-btn>
            <v-btn to="/bag" right color="primary" dark>
              <v-icon>mdi-shopping</v-icon>
              <v-badge v-if="GetBag.length > 0" top right color="secondary" :content="GetBag.length"></v-badge>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <v-footer class="above" dark color="primary" app>
      <v-container>
        <v-row align="center" justify="center">
          <v-col :cols="12" class="ma-0 pa-0 text-center">
            <p class="caption ma-0 pa-0">Disclaimer: disc recommendations are not a guarantee and used for informational purposes only. Results may vary by player skill and disc characters.</p>
            <p class="caption ma-0 pa-0">All product and company names are trademarks&trade; or registred trademarks of their respective holders. Use of them does not imply any affiliation with or endorsement by them.</p>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
  
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: 'App',

  components: {

  },

  data: () => ({
    loading: false,
  }),

  methods: {
    
  },

  computed: {
    ...mapGetters(["GetBag"]),
  },

  created: function(){
  }
};
</script>

<style scoped>
.contain {
  width: 85%;
}
.above{
  position: absolute;
  z-index: 9998;
}
</style>